import { apiFetch } from './utils/api';

export const goals = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v1/wealth-plan/goals';
    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
